import React from 'react';
// import { Order } from '../../types';
import { getDateUrgency } from '../../utils/dateUtils';
import { OrderCard } from './OrderCard';
import { OutboundOrder } from '../../../../api/warehouse/generated/src';

interface OrderListProps {
  orders: OutboundOrder[];
  onOrderSelect: (order: OutboundOrder) => void;
}

export const OrderList: React.FC<OrderListProps> = ({ orders, onOrderSelect }) => {
  const sortedOrders = orders
    .filter(o => o.status !== 'completed')
    .sort((a, b) => {
      const getPriorityScore = (order: OutboundOrder) => {
        const dateUrgency = getDateUrgency(order.deliveryDate);
        let score = 0;
        
        if (order.isManualPriority) score = 200;
        else if (order.hasPartialDelivery) score = 150;
        else if (dateUrgency === 'overdue') score = 100;
        else if (dateUrgency === 'urgent') score = 50;
        
        if (order.status === 'in-progress') score += 10;
        
        return score;
      };
      
      return getPriorityScore(b) - getPriorityScore(a);
    });

  return (
    <div className="space-y-3">
      <h2 className="text-lg font-semibold text-gray-700">Offene Aufträge</h2>
      {sortedOrders.map(order => (
        <OrderCard key={order.id} order={order} onClick={onOrderSelect} />
      ))}
    </div>
  );
};